<template>
  <div class="date-time-picker-container" v-on:click="showPicker">
    <input class="date-time-picker-input" type="text" v-bind:id="pickerId" v-bind:value="initialDueDate">

    <slot name="label"></slot>
  </div>
</template>

<script>
  import Flatpickr from 'flatpickr';
  import { cloneDeep } from 'lodash';

  export default {
    name: 'date-time-picker',

    props: {
      pickerId: {
        type: String,
        default: 'date-time-picker',
      },
      value: {
        type: [Date, String],
        default: null,
      },
      config: {
        type: Object,
        default() {
          return {};
        },
      },
      initialDueDate: {
        type: String,
        default: '',
      },
    },

    methods: {
      showPicker() {
        if (!this.picker.isOpen) {
          this.picker.open();
        }
      },
    },

    data() {
      return {
        pickerConfig: {
          defaultDate: this.value || null,
          minDate: 'today',
          enableTime: true,

          onChange: (selectedDates) => {
            this.$emit('input', cloneDeep(selectedDates[0]));
          },
        },

        picker: null,
      };
    },

    mounted() {
      const elem = document.getElementById(this.pickerId);

      this.picker = new Flatpickr(elem, this.pickerConfig);
    },

    beforeDestroy() {
      if (this.picker) {
        this.picker.destroy();
      }
    },
  };
</script>

<style>
  .flatpickr-month .flatpickr-current-month {
    top: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/DateTimePicker.vue